import { createStore, get, set, del, keys } from "idb-keyval";
import type { TemplateSettings } from "./types";

const IMAGES_STORE = createStore("crochet-images-db", "images");

export interface PersistedImage {
  id: string;
  fileName: string;
  fileType: string;
  imageHash: string;
  settings: TemplateSettings;
  createdAt: number;
  /** Original file bytes — re-decoded on hydrate so we never lose pixel fidelity. */
  bytes: ArrayBuffer;
}

export async function persistImage(rec: PersistedImage): Promise<void> {
  await set(rec.id, rec, IMAGES_STORE);
}

export async function persistImageSettings(id: string, settings: TemplateSettings): Promise<void> {
  const rec = (await get<PersistedImage>(id, IMAGES_STORE)) || null;
  if (!rec) return;
  rec.settings = settings;
  await set(id, rec, IMAGES_STORE);
}

export async function deleteImage(id: string): Promise<void> {
  await del(id, IMAGES_STORE);
}

export async function listImages(): Promise<PersistedImage[]> {
  const ids = (await keys(IMAGES_STORE)) as string[];
  const records: PersistedImage[] = [];
  for (const id of ids) {
    const rec = await get<PersistedImage>(id, IMAGES_STORE);
    if (rec) records.push(rec);
  }
  records.sort((a, b) => a.createdAt - b.createdAt);
  return records;
}

export async function clearAllImages(): Promise<void> {
  const ids = (await keys(IMAGES_STORE)) as string[];
  await Promise.all(ids.map((id) => del(id, IMAGES_STORE)));
}
